export default "__VITE_ASSET__CWUIiN9D__"